/*
 * File: DateFormatter.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Wrapper for formatting dates
 */
import { differenceInYears, format, isValid, parseISO } from "date-fns";

/**
 * Calculates age using given birth date and returns string of both
 * @param {Date} date birth date
 * @returns {String} "" if date is null/undefined, otherwise birthdate and age ex: "10/12/1989 (30Y)"
 */
const birthDate = date => {
  if (!date || !isValid(date)) return "";
  const dateString = format(date, "MM/dd/yyyy");
  const yearsOld = differenceInYears(new Date(), date);
  return `${dateString} (${yearsOld}Y)`;
};

/**
 * @param {Date} ISO 8601 date
 * @return {String} 01/09/2018
 */
const mdy = date => {
  return date ? format(parseISO(date), "MM/dd/yyyy") : "";
};

/**
 * @param {String} ISO 8601 date string
 * @return {String} 01/09/2018
 */
const time = date => {
  return date ? format(parseISO(date), "hh:mm a") : "";
};

/**
 * Swift's JSONDecoder can't handle decimals which can be returned by toISOString(),
 * so remove the decimal and anything after it before sending to API
 * @param {Date} date
 * @return {String} JSON String usable by API
 */
const forApi = date => {
  if (!date) return "";
  const isoString = date.toISOString();
  const decimalIndex = isoString.indexOf(".");
  if (decimalIndex >= 0) {
    return isoString.slice(0, decimalIndex) + "Z";
  } else {
    return isoString;
  }
};

const DateFormatter = {
  birthDate: birthDate,
  mdy: mdy,
  forApi: forApi,
  time: time
};

export default DateFormatter;
